const mapboxToken = 'pk.eyJ1IjoieXVyaXZpc2giLCJhIjoiQWEzV1NoayJ9.nhSVbyLvskEZqC-ie8wFIA';
export default mapboxToken
